import { PushNotificationTokenType } from 'APP/model/pushNotifications/pushNotificationsModel.types';

import { getUserPermission } from './getUserPermission';
import { registerNotifications } from './registerNotifications';

export const subscribeNotifications = async (): Promise<void> => {
  const permission = await getUserPermission();

  if (permission !== 'granted') {
    return;
  }

  registerNotifications(PushNotificationTokenType.default);
  registerNotifications(PushNotificationTokenType.voip);
};
